<dsp-content-card [types]="[ 'datepicker', 'datepicker' ]" [loading]="loading$ | async">

  <atlas-field *dsp-content-filter class="dsp-documents-datepicker-hack" [widthValue]="270"
    [fullWidth]="(isMobile$ | async)" [style.--radius-xsmall]="'4px'" [id]="'documents-from-filter'"
    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium">
    <atlas-field-label>From</atlas-field-label>
    <input [(ngModel)]="from" atlasInput [min]="'1900-01-01'" [max]="to" [Datepicker]="pickerFrom"
      placeholder="Day Month Year" (ngModelChange)="onChangeFrom($event)" [readonly]="true" />
    <atlas-field-suffix>
      <datepicker-toggle [datepicker]="pickerFrom"></datepicker-toggle>
    </atlas-field-suffix>
    <datepicker #pickerFrom> </datepicker>
  </atlas-field>

  <atlas-field *dsp-content-filter [widthValue]="270" [fullWidth]="(isMobile$ | async)" [style.--radius-xsmall]="'4px'"
    [id]="'documents-to-filter'" [size]="(isMobile$ | async) ? sizeSmall : sizeMedium">
    <atlas-field-label>To</atlas-field-label>
    <input [(ngModel)]="to" atlasInput [min]="from" [max]="todaysDate" [Datepicker]="pickerTo"
      placeholder="Choose a date" (ngModelChange)="onChangeTo($event)" [readonly]="true" />
    <atlas-field-suffix>
      <datepicker-toggle [datepicker]="pickerTo"></datepicker-toggle>
    </atlas-field-suffix>
    <datepicker #pickerTo> </datepicker>
  </atlas-field>

  <div dsp-content>
    <atlas-tab-group [fullWidth]="false" [ngClass]="{ 
      'dsp-mobile-tabs' : (isMobile$ | async),
      'dsp-mobile-strategic-spacing': (isMobile$ | async) && type === 'strategic-research'
    }" [selectedIndex]="selectedTabIndex$ | async" (selectedIndexChange)="changeTab($event)">
      <atlas-tab>
        <ng-template atlas-tab-label>
          Strategic Research
        </ng-template>
      </atlas-tab>
      <atlas-tab>
        <ng-template atlas-tab-label>
          Client Documents
        </ng-template>
      </atlas-tab>
      <atlas-tab
        *ngIf=" (internal$ | async) || (!(internal$ | async) && (productDocument$ | async) && (displayProductTab$ |async))">
        <ng-template atlas-tab-label>
          Product Documents
        </ng-template>
      </atlas-tab>
      <atlas-tab *ngIf="env.micEnabled === 'true'">
        <ng-template atlas-tab-label>
          MercerInsight(R) Community
        </ng-template>
      </atlas-tab>
      <div *ngIf="message" class="alert"
        [ngClass]="(showProductData$ | async) ? 'green-product-msg' : 'red-product-msg'">
        <p>{{message}}</p>
      </div>
      <div *ngIf="showDesc" class="product-doc-desc">
        <div *ngIf="country === 'au'">
          <span>Access publically available Product Documents through these links - </span>
          <br>
          <a href="{{singleSectorFunds}}" target="_blank">Single Sector Funds</a>
          <br>
          <a href="{{diversifiedFunds}}" target="_blank">Diversified Funds</a>
        </div>
        <div *ngIf="country === 'nz'">
          <span>Access publically available Product Documents through this link - </span><a href="{{mercerNewZealand}}"
            target="_blank">Mercer New Zealand</a>
        </div>
      </div>
    </atlas-tab-group>
    <ng-container *ngIf="type==='mercer-insight-community'">
      <p>
        MercerInsight® Community helps enable the dynamic sharing of insights and opportunities among asset owners and
        managers from across the global investment industry. Members gain free access to personalised, curated research
        to inform investment decisions. Content providers have the opportunity to share their latest research and ideas,
        feature articles, attract an audience and receive crowd-sourced feedback.</p>

      <div class="mos-c-accordion--raised">

        <atlas-accordion><atlas-accordion-item #accordionRef2>

            <atlas-accordion-heading>
              <div class="row">
                <div class="columns shrink mos-o-body-2">MIC List View</div>
                <div class="columns">
                </div>
              </div>
            </atlas-accordion-heading>
            <atlas-accordion-content>
              <div class="row">
                <div class="columns small-12 medium-12">
                  <div *ngIf="(documents$ | async)" style="width:100%">
                    <div class="hcard">
                      <div class="hcard__left"><a href={{document.url}} target="_blank" *ngIf="i%2===0">
                          <atlas-avatar imgSrc="/assets/images/mic-img1.png" imgAlt="Mic feature Img" size="large"
                            color="brand">
                          </atlas-avatar>
                        </a>
                        <a href={{document.url}} target="_blank" *ngIf="i%2!==0">
                          <atlas-avatar imgSrc="/assets/images/mic-img2.png" imgAlt="Mic feature Img" size="large"
                            color="brand"> </atlas-avatar>

                        </a>
                      </div>
                      <div class="hcard__center">
                        <div class="vcard">
                          <h6 class="hcard__name">{{document.contentType}}</h6>
                          <a href={{document.url}} target="_blank">
                            <h4 class="hcard__org">{{capitalizeFirstLetter(document.title)}}</h4>
                          </a>
                          <h6 class="mos-c-hcard--fn fn">{{document.date | date:'mediumDate'}}</h6>


                        </div>
                      </div>
                      <div class="hcard__right"></div>
                    </div>
                  </div>
                </div>

              </div>
            </atlas-accordion-content>


            <atlas-accordion-expand>
              <div>
                <atlas-icon-button icon="icon-arrow-enlarge-regular-24"></atlas-icon-button>
              </div>
            </atlas-accordion-expand>
          </atlas-accordion-item>
        </atlas-accordion>
        <atlas-accordion><atlas-accordion-item #accordionRef4>

            <atlas-accordion-heading>
              <div class="row">
                <div class="columns shrink mos-o-body-2">MIC Card View</div>
                <div class="columns">
                </div>
              </div>
            </atlas-accordion-heading>
            <atlas-accordion-content>
              <div class="row mos-u-spacer--margin-top-lg">
                <div class="column small-12 medium-4" *ngFor="let document of documents$ | async;let i = index">
                  <atlas-card fullWidth="true" elevation="raised">
                    <atlas-card-header>
                      <h3>{{capitalizeFirstLetter(document.title)}}</h3>
                    </atlas-card-header>
                    <atlas-card-content>
                      <a href={{document.url}} target="_blank" *ngIf="i%2===0">
                        <img width="auto" src='/assets/images/mic-img1.png' alt=" Mic feature Img"></a>
                      <a href={{document.url}} target="_blank" *ngIf="i%2!==0">
                        <img width="auto" src='/assets/images/mic-img2.png' alt=" Mic feature Img"></a>

                      <p>{{formatDate(document.date, 'DD/MM/YYYY')}}
                        <br>{{document.excerpt}}
                      </p>
                    </atlas-card-content>
                    <atlas-card-footer>
                      <a href="{{document.url}}" target="_blank">
                        <atlas-button-group variant="outlined">

                          <button #buttonGroup [style.flex]="1" type="button" variant="text">View
                            More</button>

                        </atlas-button-group>
                      </a>
                    </atlas-card-footer>
                  </atlas-card>
                </div>

              </div>

            </atlas-accordion-content>


            <atlas-accordion-expand>
              <div>
                <atlas-icon-button icon="icon-arrow-enlarge-regular-24"></atlas-icon-button>
              </div>
            </atlas-accordion-expand>
          </atlas-accordion-item>
        </atlas-accordion>

        <atlas-accordion><atlas-accordion-item #accordionRef5>

            <atlas-accordion-heading>
              <div class="row">
                <div class="columns shrink mos-o-body-2">MIC Single Card View</div>
                <div class="columns">
                </div>
              </div>
            </atlas-accordion-heading>
            <atlas-accordion-content>
              <div class="row mos-u-spacer--margin-top-lg">
                <div class="column small-12 medium-6" *ngFor="let document of documents$ | async;let i = index">
                  <atlas-card fullWidth="true" elevation="raised">
                    <atlas-card-content>
                      <div class="row">
                        <div class="column md-4">
                          <a href={{document.url}} target="_blank" *ngIf="i%2===0">
                            <img width="auto" src='/assets/images/mic-img1.png' alt=" Mic feature Img"></a>
                          <a href={{document.url}} target="_blank" *ngIf="i%2!==0">
                            <img width="auto" src='/assets/images/mic-img2.png' alt=" Mic feature Img"></a>
                        </div>
                        <div class="column md-8">
                          <h3><b>{{capitalizeFirstLetter(document.title)}}</b></h3>
                          <p>{{formatDate(document.date, 'DD/MM/YYYY')}}
                            <br>{{document.excerpt}}
                          </p>
                        </div>
                      </div>
                      <a href="{{document.url}}" target="_blank"><b>Show More</b></a>
                    </atlas-card-content>

                  </atlas-card>
                </div>
              </div>
            </atlas-accordion-content>


            <atlas-accordion-expand>
              <div>
                <atlas-icon-button icon="icon-arrow-enlarge-regular-24"></atlas-icon-button>
              </div>
            </atlas-accordion-expand>
          </atlas-accordion-item>
        </atlas-accordion>
      </div>

    </ng-container>
    <div *ngIf="(isMobile$ | async) && !(type==='mercer-insight-community')"
      [ngClass]="{ 'dsp-mobile-documents-list': true, 'dsp-mobile-strategic-spacing': type === 'strategic-research' || type === 'client-documents'  }">
      <dsp-mobile-document-card *ngFor="let file of mobileDocuments$ | async" [file]="file"
        (click)="exportPDF(file._id, file.originalName)">
      </dsp-mobile-document-card>
      <div class="mos-u-spacer--margin-bottom-md" *ngIf="showLoadMore$ | async">
        <atlas-button [expand]="true" [style]="'strong'" (click)="onLoadMore()">Load More</atlas-button>
      </div>
    </div>

    <ng-container *ngIf="!(isMobile$ | async) && !(type==='mercer-insight-community')">
      <atlas-table [customSort]="true">
        <thead atlas-table-header #header>

          <tr atlas-table-row>
            <th atlas-table-header-cell *ngFor="let col of headers" [columnDef]="col"
              [ngClass]="{ 'dsp-action-header': col.fieldKey === 'action' }"
              (click)="onSort(col.fieldKey,header.sortOption.direction)">
              <span [ngClass]="{ 'dsp-action-header-label': col.fieldKey === 'action' }">
                {{ col.displayLabel }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody atlas-table-body>
          <!-- <tr halo-table-row *ngFor="let row of documents$ | async | sort:header.sortOption"> -->
          <tr halo-table-row *ngFor="let row of documents$ | async">

            <td atlas-table-cell>
              {{ formatDate(row.date, 'DD/MM/YYYY') }}
            </td>
            <td atlas-table-cell class="mos-u-text-overflow">
              {{ row.title }}
            </td>
            <td atlas-table-cell class="mos-u-text-overflow typographyStyles-body-small"
              [innerHTML]="row.fund ? row.fund : '-'"></td>
            <td atlas-table-cell class="mos-u-text-right">

              <button>
                <atlas-icon [icon]="'download'" (click)="exportPDF(row._id, row.originalName)"></atlas-icon>
              </button>
            </td>

          </tr>
        </tbody>
      </atlas-table>
    </ng-container>

    <div class="mos-u-spacer--margin-top-sm row" *ngIf="!(isMobile$ | async) && !(type==='mercer-insight-community')">
      <div class="column medium-3 pagination-container" style="justify-content: left;">
        <span>
          Showing {{
          (((pagination$ | async)?.page - 1) * (pagination$ | async)?.itemsByPage + 1)
          }} to {{
          getMin((pagination$ | async)?.page * (pagination$ | async)?.itemsByPage, (pagination$ | async)?.total)
          }} of {{ (pagination$ | async)?.total }} entries
        </span>
      </div>

      <atlas-pagination *ngIf="(pagination$ | async)?.total" (paginationInfoRequest)="onPaginate($event)"
        [paginationInfo]="pagination$ | async" [showLimitOptions]="true">
      </atlas-pagination>
    </div>
  </div>
</dsp-content-card>